import React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ROUTE_NUMBER_COUNT } from "@/constants/config";
import { MAX_FLIGHT_RANGE, MAX_PANORAMA_SEARCH_DAYS } from "@/constants/membership";

const Faq = () => {
  return (
    <Box>
      <Box marginBottom={4}>
        <Typography fontWeight={700} variant={"h3"} align={"center"} color={"textSecondary"}>
          Frequently Asked Questions
        </Typography>
      </Box>
      <Box>
        {[
          {
            title: "How long does it usually take to get full real-time data?",
            subtitle:
              "It takes 10 seconds on average to get the data fully ready. And it might take a big longer for international routes.",
          },
          {
            title: "How can I get more alerts?",
            subtitle: "Pro user can have up to 25 alerts. Thanks for your support!",
          },
          {
            title:
              "How can view the whole year of route data or search a larger range of route data?",
            subtitle:
              "Pro user can search up to " + MAX_PANORAMA_SEARCH_DAYS + "-day range for the whole year data. Thanks for your support!",
          },
          {
            title: "What does " + MAX_FLIGHT_RANGE + "-entry search mean?",
            subtitle:
              "This is a fantastic PRO feature. One origin, one arrival, and one day is one entry. With " +
              MAX_FLIGHT_RANGE +
              "-entry, you're able to search one route for " +
              MAX_FLIGHT_RANGE +
              " days, or you can search 1 airport to 2 airports for " +
              MAX_FLIGHT_RANGE / 2 +
              " days, and so on. You have the full control of how you want to leverage this powerful feature.",
          },
          {
            title: "What's the source of the data?",
            subtitle:
              "We don't host any web crawler to collect data directly from website. There are mainly two sources. 1) Our primary source is from multiple highly dependable data providers, from which we source majority of our data. And we have a top-tier team of engineers dedicated to collecting and processing thise data to ensure its readiness for you.  2) Some airlines grant us access to their availability data via APIs. We continually enhance our data collection and processing procedures to provide you with the best information.",
          },
          {
            title:
              "Why are certain programs supported in real-time search but not in the route feature, or vice versa?",
            subtitle:
              "Managing " + ROUTE_NUMBER_COUNT.toLocaleString() + "+ of routes presents significant resource demands and numerous challenges. The real-time search feature, in particular, imposes stringent latency requirements, adding to the complexity. These features encounter distinct technical hurdles. We are proactively solving these issues and intend to broaden support for additional programs within each feature in the future",
          },
          {
            title: "Are you going to support more loyalty programs?",
            subtitle:
              "Certainly! We are collaborating closely with both our data provider and the airlines themselves to bring additional loyalty programs onto our platform, such as British Airways Avois, ANA Mileage Club, HawaiianMiles, and more. Keep an eye out for updates!",
          },
          {
            title: "Is this a free service?",
            subtitle:
              "Yes, we're providing our quality service for free! However, in order to support our operation, we do charge Pro user for our amazing premium functions, like 25 multicity & multiday alerts, " +
              MAX_FLIGHT_RANGE +
              "-entry search, year-round route data. And we aim to provide the best yet the most afford plan for our PRO users to save thousands and hours.  We're also working on some other premium features, like better data visualization, data analysis, AI integration, and more. Stay tuned!",
          },
          // {
          //   title: "How did you manage to create such an impressive website?",
          //   subtitle:
          //     "Leveraging open-source libraries like Material UI, we combine innovative design, user-focused development, and iterative feedback to create intuitive, aesthetically pleasing, and functional websites.",
          // },
        ].map((item, i) => (
          <Box
            component={Accordion}
            key={i}
            padding={1}
            marginBottom={i === item.length - 1 ? 0 : 2}
            borderRadius={2}
            sx={{
              "&::before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id={`panel1a-header--${i}`}
            >
              <Typography fontWeight={600}>{item.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="text.secondary">{item.subtitle}</Typography>
            </AccordionDetails>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Faq;
